// extracted by mini-css-extract-plugin
export var active = "_ip-e";
export var blink = "_ip-f";
export var dropDownSelector = "_ip-5";
export var dropDownWrapper = "_ip-4";
export var fakeCursor = "_ip-d";
export var fontSizeButton = "_ip-7";
export var formQuillEditor = "_ip-0";
export var pressed = "_ip-g";
export var qlBlank = "_ip-1";
export var textFormattingToolbar = "_ip-2";
export var textFormattingToolbarClosed = "_ip-3";
export var textFormattingToolbarInline = "_ip-6";
export var textToolbarOption = "_ip-8";
export var toolbarCell = "_ip-a";
export var toolbarCellCollapsed = "_ip-b";
export var toolbarOptionHitArea = "_ip-c";
export var toolbarOverflow = "_ip-9";